import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.dev';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  constructor(private httpClient: HttpClient) { }

  getUserProfile(token: string){
    return this.httpClient.get<any>(`${environment.keycloak.keycloakUrl}/realms/${environment.keycloak.realm}/protocol/openid-connect/userinfo`);
  }
}
